import React from "react";
import styled from "styled-components";
import { EMAIL_STATUS } from "../../constants";
import InfoIcon from "src/img/new/info.svg";
import InfoBlueIcon from "src/img/new/info-2.svg";
import resendIcon from "src/img/new/resend.svg";

const StatusBadge = styled.div`
    width: 91px;
    height: 26px;
    background-color: ${p => p.backgroundColor};
    background-clip: padding-box;
    border: ${p => p.border};
    border-radius: 8px;
    opacity: 1;

    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    color: ${p => p.color};
    font-size: 12px;

    text-transform: capitalize;
`;

const FailedBadge = styled(StatusBadge)`
    justify-content: space-between;
`;

const Icon = styled.img`
    width: ${p => p.width || "16px"};
    height: ${p => p.height || "16px"};
`;

const ResendBadge = styled(StatusBadge)`
    width: 91px;
    height: 30px;
    background: #171A22;
    color: #FFFFFF;
    cursor: pointer;
    gap: 10px;
    justify-content: space-between;
`;

const InfoCard = styled.div`
    display: none; /* hidden by default */
    position: absolute;
    left: 12px;
    bottom: 16px;
    width: 235px;
    height: 46px;
    background: rgba(91, 110, 245, 0.12);
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.12);
    border: 1px solid #171A22;
    border-radius: 8px;
    align-items: center;
    gap: 10px;
    padding: 0 10px;
    font-size: 12px;
    color: #171A22;
    z-index: 10;
    text-align: left; 
`;

const InfoIconWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    
    &:hover ${InfoCard} {
        display: flex;
    }
`;


export default function TableStatus(props) {
    const { status, campaignUuid, onResend } = props;

    const renderResend = () => (
        <ResendBadge onClick={e => { e.stopPropagation(); onResend?.(campaignUuid); }}>
            Resend
            <Icon src={resendIcon} alt="Resend" />
        </ResendBadge>
    );
    
    const renderInfoBadge = () => (
        <InfoIconWrapper style={{ position: "relative" }}>
            <Icon src={InfoIcon} alt="Info" />
            <InfoCard>
                <Icon src={InfoBlueIcon} alt="Info" width="20px" height="20px"/>
                <div>Delivery failed for some recipients. Click Resend to try again.</div>
            </InfoCard>
        </InfoIconWrapper>
    );

    switch (status) {
        case EMAIL_STATUS.SENT:
            return (
                <StatusBadge backgroundColor="rgba(91, 110, 245, 0.12)" border="1px solid #171A22" color="#171A22">{EMAIL_STATUS.SENT}</StatusBadge>
            );
        case EMAIL_STATUS.SCHEDULED:
            return (
                <StatusBadge backgroundColor="rgba(91, 110, 245, 0.12)" border="1px solid #171A22" color="#171A22">{EMAIL_STATUS.SCHEDULED}</StatusBadge>
            );
        case EMAIL_STATUS.DRAFT:
            return (
                <StatusBadge backgroundColor="#171A22" border="1px solid #171A22" color="#FFFFFF">{EMAIL_STATUS.DRAFT}</StatusBadge>
            );
        case EMAIL_STATUS.QUEUED:
        case EMAIL_STATUS.SENDING:
            return (
                <StatusBadge backgroundColor="#EFE7FF" border="1px solid #633FE4" color="#633FE4">{EMAIL_STATUS.SENDING}</StatusBadge>
            );
        case EMAIL_STATUS.FAILED:
            return (
                <div style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "flex-start" }}>
                    <FailedBadge backgroundColor="#FFF5F5" border="1px solid #FF3B3B" color="#FF3B3B">
                        {EMAIL_STATUS.FAILED}
                        {renderInfoBadge()}
                    </FailedBadge>
                    {renderResend()}
                </div>
            );
        default:
            return null;
    }
}
